import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";
import {InitialRequestParams} from "../../../core/models/initial-request-params";
import {FullGameResponseFactory} from "./full-game-response-factory";
import {BaseUtilsService} from "../../../infrastructure/domain-services/base-utils-service";

export class FullGameResponseApi extends BaseApiService {

  static injectables = [...BaseUtilsService.injectables, FullGameResponseFactory];

  url(requestParams: InitialRequestParams) {
    const route = this.root + requestParams.toString();
    return route;
  }
}

